export default {
    bindings: {
        content: '<'
    },
    controller: 'paymentController',
    template: require('../views/payment.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/payment.component.js